import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import ButtonBase from '@material-ui/core/ButtonBase'
import Card from '@material-ui/core/Card'
import CrossfadeImage from './CrossfadeImage'
import MapActions from '../redux/mapRedux'
import {
  SATELLITE_BASEMAP_TOGGLE_URL,
  STREET_BASEMAP_TOGGLE_URL,
  STREET_BASEMAP_STYLE
} from '../config/constants'
import { pointToTile } from '@mapbox/tilebelt'

const styles = theme => ({
  button: {
    // position: 'absolute',
    // bottom: 30,
    // right: 10
  },
  card: {
    width: 50,
    height: 50,
    margin: 0
  }
})

const StyleToggle = props => {
  const { actions, classes, toggleCenter, toggleZoom, style } = props

  if (!toggleCenter || !toggleCenter.lng || ! toggleZoom) {
    return null
  }
  
  const zoom = toggleZoom > 14 ? 14 : toggleZoom  

  const tile = pointToTile(toggleCenter.lng, toggleCenter.lat, Math.trunc(zoom))
  const BASEMAP_TOGGLE_URL =
    style === STREET_BASEMAP_STYLE
      ? SATELLITE_BASEMAP_TOGGLE_URL
      : STREET_BASEMAP_TOGGLE_URL
  const url = BASEMAP_TOGGLE_URL(tile[0], tile[1], zoom)
  return (
    <Tooltip id='tooltip-style-toggle' title='toggle basemap' placement='left'>
      <ButtonBase className={classes.button} onClick={actions.styleToggled}>
        <Card className={classes.card}>
          <CrossfadeImage
            src={url}
            duration={1000}
            timingFunction={'ease-out'}
          />
        </Card>
      </ButtonBase>
    </Tooltip>
  )
}

const mapStateToProps = state => {
  return {
    style: state.map.style,
    toggleCenter: state.map.toggleCenter,
    toggleZoom: state.map.toggleZoom
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      styleToggled: () => dispatch(MapActions.styleToggled())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(StyleToggle)
)



// WEBPACK FOOTER //
// ./src/components/StyleToggle.js